export enum LandingPage {
    FleetManager = '/fleet-manager/overview',
    Carrier = '/carrier/credit-check',
    Factoring = '/portal/dashboard',
  }


// WEBPACK FOOTER //
// ./src/app/core/models/landing-page.enum.ts